import React from 'react';
import { Grid, Tab, Form, Button, Icon, Search } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import axios from 'axios';
import Spinner from '../UI/Spinner/Spinner';
import { Link } from 'react-router-dom';
import { REGULAR_PATH } from '../../../env';
import moment from 'moment';
import * as ExcelJS from 'exceljs/dist/exceljs.js';

const baseURL = REGULAR_PATH;

class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      connectedAssets: [],
      name: 'DEFAULT',
      password: '',
      email: 'Not provided',
      emailVerified: false,
      mobile: 'Not provided',
      mobileVerified: false,
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      loader: false,
      appNotification: false,
      mailNotification: false,
      smsNotification: false,
      hasNotificationSetting: false,
      assetFilter: {
        id: false,
        name: false,
        chassisNumber: false,
        engineNumber: false,
        deviceNumber: false,
      },
      assetSort: {
        valid: '',
        active: 'asc',
      },
    };

    this.token = window.localStorage.getItem('user');
  }

  componentDidMount() {
    axios
      .get(`${baseURL}/user/profile?access_token=${this.token}`)
      .then((response) => {
        const {
          password,
          name,
          email,
          email_verified,
          mobile,
          mobile_verified,
        } = response.data;
        this.setState({
          password: password,
          name: name,
          emailVerified: email_verified,
          email: email,
          mobile: mobile,
          mobileVerified: mobile_verified,
        });
        return axios.get(`${baseURL}/user/assets?access_token=${this.token}`);
      })
      .then((response) => {
        const { assets } = response.data;
        this.setState({
          connectedAssets: assets.sort((a, b) => (a.name > b.name ? 1 : -1)),
        });
      })
      .catch((error) => {});
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  handleSubmit = () => {
    const { currentPassword, newPassword } = this.state;

    let header = {
      headers: { 'Content-Type': 'text/plain' },
    };
    if (this.state.password) {
      let body = {
        old_password: currentPassword,
        new_password: newPassword,
      };
      if (currentPassword !== '' && newPassword.length > 5) {
        axios
          .put(
            `${baseURL}/user/change_password?access_token=${this.token}`,
            body,
            header,
          )
          .then((response) => {
            //(response.data.success);
            if (response.data.success) {
              toast.success(response.data.status, {
                position: toast.POSITION.TOP_CENTER,
              });
            } else {
              toast.error(response.data.status, {
                position: toast.POSITION.TOP_CENTER,
              });
            }
          })
          .catch(() => {
            toast.error('Please provide your correct password !', {
              position: toast.POSITION.TOP_CENTER,
            });
          });
      }
    } else {
      if (newPassword.length > 5) {
        let body = {
          new_password: newPassword,
        };
        axios
          .post(
            `${baseURL}/user/new_password?access_token=${this.token}`,
            body,
            header,
          )
          .then((response) => {
            if (response.status) {
              toast.success('Successfully inserted !', {
                position: toast.POSITION.TOP_CENTER,
              });
            }
          })
          .catch((error) => {
            //(error);
            toast.error('Please provide your password !', {
              position: toast.POSITION.TOP_CENTER,
            });
          });
      } else {
        toast.error('Please provide your password minimum six character!', {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }
    this.setState({
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      loader: true,
    });
  };

  handleAssetFilter = (column, action) => {
    if (column === 'id') {
      this.setState({
        assetFilter: {
          id: action,
          name: false,
          chassisNumber: false,
          engineNumber: false,
          deviceNumber: false,
        },
      });
    } else if (column === 'name') {
      this.setState({
        assetFilter: {
          id: false,
          name: action,
          chassisNumber: false,
          engineNumber: false,
          deviceNumber: false,
        },
      });
    } else if (column === 'chassisNumber') {
      this.setState({
        assetFilter: {
          id: false,
          name: false,
          chassisNumber: action,
          engineNumber: false,
          deviceNumber: false,
        },
      });
    } else if (column === 'engineNumber') {
      this.setState({
        assetFilter: {
          id: false,
          name: false,
          chassisNumber: false,
          engineNumber: action,
          deviceNumber: false,
        },
      });
    } else if (column === 'deviceNumber') {
      this.setState({
        assetFilter: {
          id: false,
          name: false,
          chassisNumber: false,
          engineNumber: false,
          deviceNumber: action,
        },
      });
    }
  };

  handleAssetSort = (column, action) => {
    if (column === 'valid') {
      this.setState({ assetSort: { valid: action, active: false } });
    } else if (column === 'active') {
      this.setState({ assetSort: { valid: false, active: action } });
    }
  };

  downloadExcel = () => {
    const { connectedAssets } = this.state;
    const workbook = new ExcelJS.Workbook();
    workbook.creator = 'Finder GPS Tracking';
    workbook.created = new Date();

    workbook.addWorksheet('Asset List');

    const worksheet = workbook.getWorksheet('Asset List');

    worksheet.addRow(['Finder GPS Tracking']);
    worksheet.addRow(['Asset List']);
    worksheet.addRow([
      `Generated on ${moment().format('MMMM Do, YYYY, hh:mm:ss A')}`,
    ]);
    worksheet.addRow([`Generated By: ${window.localStorage.getItem('email')}`]);

    worksheet.addRow();

    worksheet.addRow();

    worksheet.columns = [
      { width: 10 },
      { width: 20 },
      { width: 30 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
    ];

    const headerCells = [
      'Sl No',
      'Asset ID',
      'Asset Name',
      'Bill Clear Up To',
      'Active',
    ];

    const installationDateEnabled = ['660e2797faf103f4ae9b9c8d'].includes(
      window.localStorage.getItem('organization'),
    );

    const chassisEnabled = [
      '6020bcbf1d41c84da5bcb6a3',
      '660e2797faf103f4ae9b9c8d',
      '5a8980b01d41c873277771d1',
      '5abcca6a1d41c85ce9da4f80',
      '6992a801646454e3da6bd819',
    ].includes(window.localStorage.getItem('organization'));

    const engineEnabled = ['660e2797faf103f4ae9b9c8d'].includes(
      window.localStorage.getItem('organization'),
    );

    const deviceNumberEnabled = ['6431047b0b77d9736270689e', '5a8980b01d41c873277771d1', '5abcca6a1d41c85ce9da4f80'].includes(
      window.localStorage.getItem('organization'),
    );

    if (chassisEnabled) {
      headerCells.splice(3, 0, 'Chassis Number');
    }

    if (engineEnabled) {
      headerCells.splice(4, 0, 'Engine Number');
    }
    if (deviceNumberEnabled) {
      headerCells.splice(3, 0, 'Device Number');
    }
    if (installationDateEnabled) {
      headerCells.splice(5, 0, 'Installation Date');
    }

    const headerRow = worksheet.addRow(headerCells);

    // Style the header row
    headerRow.eachCell((cell) => {
      cell.font = {
        bold: true,
        color: { argb: 'FF000000' }, // White
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'CCCCCC' }, // Black
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    connectedAssets.forEach(
      (
        {
          asset_id,
          name,
          valid_till,
          chasis_number,
          engine_number,
          active,
          device_number,
          installation_date,
        },
        index,
      ) => {
        const rowData = [
          index + 1,
          asset_id,
          name,
          valid_till
            ? moment(valid_till.$date)
                .utc(true)
                .local()
                .format('DD/MM/YY, H:mm A')
            : '-',
          active ? 'Yes' : 'No',
        ];
        if (chassisEnabled) {
          rowData.splice(3, 0, chasis_number);
        }
        if (engineEnabled) {
          rowData.splice(4, 0, engine_number);
        }
        if (deviceNumberEnabled) {
          rowData.splice(3, 0, device_number);
        }
        if (installationDateEnabled) {
          rowData.splice(
            5,
            0,
            installation_date
              ? moment(installation_date.$date)
                  .utc(true)
                  .local()
                  .format('DD/MM/YY, H:mm A')
              : '-',
          );
        }

        worksheet.addRow(rowData);
      },
    );

    // Align the first column (No) to the left
    worksheet.eachRow((row, rowNumber) => {
      const cell = row.getCell(1);
      cell.alignment = { vertical: 'middle', horizontal: 'left' };
    });

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: 'application/octet-binary',
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Asset_List_${moment().format(
        'MMMM Do, YYYY, hh:mm:ss A',
      )}.xlsx`;
      a.click();
      a.remove();
    });
  };

  render() {
    const {
      connectedAssets,
      name,
      password,
      email,
      mobile,
      emailVerified,
      mobileVerified,
      currentPassword,
      newPassword,
      confirmPassword,
      assetFilter,
      assetSort,
    } = this.state;

    let connectedAssetsView;
    let currentPasswordComponent;
    let newAndConfirmedPasswordMatch;
    if (newPassword.length > 0 && confirmPassword.length > 0) {
      if (newPassword === confirmPassword) {
        newAndConfirmedPasswordMatch = true;
      } else {
        newAndConfirmedPasswordMatch = false;
      }
    } else {
      newAndConfirmedPasswordMatch = false;
    }

    if (connectedAssets.length > 0) {
      connectedAssetsView = connectedAssets
        .filter(
          ({ asset_id, name, chasis_number, engine_number, device_number }) => {
            if (typeof assetFilter.id === 'string' && assetFilter.id) {
              return asset_id
                .toLowerCase()
                .includes(assetFilter.id.toLowerCase());
            } else if (
              typeof assetFilter.name === 'string' &&
              assetFilter.name
            ) {
              return name
                .toLowerCase()
                .includes(assetFilter.name.toLowerCase());
            } else if (
              typeof assetFilter.chassisNumber === 'string' &&
              assetFilter.chassisNumber
            ) {
              return chasis_number
                .toLowerCase()
                .includes(assetFilter.chassisNumber.toLowerCase());
            } else if (
              typeof assetFilter.engineNumber === 'string' &&
              assetFilter.engineNumber
            ) {
              return engine_number
                .toLowerCase()
                .includes(assetFilter.engineNumber.toLowerCase());
            } else if (
              typeof assetFilter.deviceNumber === 'string' &&
              assetFilter.deviceNumber
            ) {
              return device_number
                .toLowerCase()
                .includes(assetFilter.deviceNumber.toLowerCase());
            } else {
              return true;
            }
          },
        )
        .sort((a, b) => {
          const { valid, active } = assetSort;
          if (valid === 'asc') {
            return a.valid_till.$date - b.valid_till.$date;
          } else if (valid === 'dsc') {
            return b.valid_till.$date - a.valid_till.$date;
          } else if (active === 'asc') {
            return a.active - b.active;
          } else if (active === 'dsc') {
            return b.active - a.active;
          }
          return true;
        })
        .map((asset, index) => (
          <tr key={index}>
            <td>{asset.asset_id}</td>
            <td>{asset.name}</td>
            {[
              '6020bcbf1d41c84da5bcb6a3',
              '660e2797faf103f4ae9b9c8d',
              '5a8980b01d41c873277771d1',
              '5abcca6a1d41c85ce9da4f80',
              '6992a801646454e3da6bd819',
            ].includes(window.localStorage.getItem('organization')) ? (
              <td>{asset.chasis_number}</td>
            ) : null}
            {['660e2797faf103f4ae9b9c8d'].includes(
              window.localStorage.getItem('organization'),
            ) ? (
              <td>{asset.engine_number}</td>
            ) : null}

            {['6431047b0b77d9736270689e', '5a8980b01d41c873277771d1', '5abcca6a1d41c85ce9da4f80'].includes(
              window.localStorage.getItem('organization'),
            ) ? (
              <td>{asset.device_number}</td>
            ) : null}

            {['660e2797faf103f4ae9b9c8d'].includes(
              window.localStorage.getItem('organization'),
            ) ? (
              <td>
                {asset.installation_date
                  ? moment(asset.installation_date.$date).format('MMMM Do, YYYY')
                  : '-'}
              </td>
            ) : null}

            <td>
              {asset.valid_till
                ? moment(asset.valid_till.$date).format('MMMM Do, YYYY')
                : null}
            </td>
            <td>{asset.active ? 'Yes' : 'No'}</td>
          </tr>
        ));
    } else {
      connectedAssetsView = 'No data found';
    }

    if (password) {
      currentPasswordComponent = (
        <Form.Group>
          <Form.Input
            label='Current password'
            type='password'
            placeholder='Password'
            name='currentPassword'
            value={currentPassword}
            onChange={this.handleChange}
          />
        </Form.Group>
      );
    } else {
      currentPasswordComponent = null;
    }

    const panes = [
      {
        menuItem: 'Basic info',
        render: () => (
          <Tab.Pane attached={false}>
            <div className='profile-table'>
              <table>
                <tbody>
                  <tr>
                    <td className='width-200'>Name</td>
                    <td>{name}</td>
                  </tr>
                  {mobile && (
                    <tr>
                      <td className='width-200'>Mobile number</td>
                      <td>{mobile}</td>
                    </tr>
                  )}
                  {mobile && (
                    <tr>
                      <td className='width-200'>Mobile verified</td>
                      <td>{mobileVerified ? 'Yes' : 'No'}</td>
                    </tr>
                  )}
                  {email && (
                    <tr>
                      <td className='width-200'>Email</td>
                      <td>{email}</td>
                    </tr>
                  )}
                  {email && (
                    <tr>
                      <td className='width-200'>Email verified</td>
                      <td>{emailVerified ? 'Yes' : 'No'}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Tab.Pane>
        ),
      },
      {
        menuItem: 'Assets',
        render: () => (
          <Tab.Pane attached={false}>
            <div className='profile-table'>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <h3>Assets</h3>
                <div
                  style={{
                    display: 'flex',
                    gap: 20,
                    fontWeight: 600,
                    fontSize: 16,
                  }}
                >
                  <div>Total: {connectedAssets.length}</div>
                  <div>
                    Active:&nbsp;
                    {connectedAssets.filter(({ active }) => active).length}
                  </div>
                  <div>
                    {[
                      '6020bcbf1d41c84da5bcb6a3',
                      '6992a801646454e3da6bd819',
                    ].includes(window.localStorage.getItem('organization'))
                      ? 'Closed: '
                      : 'Inactive: '}
                    {connectedAssets.filter(({ active }) => !active).length}
                  </div>
                </div>

                <Button onClick={this.downloadExcel}>Download</Button>
              </div>
              <table>
                <thead>
                  <tr>
                    <th>
                      {assetFilter.id ? (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Search
                            onSearchChange={(e, data) =>
                              this.handleAssetFilter('id', data.value)
                            }
                            value={
                              typeof assetFilter.id === 'string'
                                ? assetFilter.id
                                : ''
                            }
                            placeholder='Search Here...'
                            showNoResults={false}
                            style={{ width: '200px' }}
                          />
                          <Button
                            icon
                            onClick={() => this.handleAssetFilter('id', false)}
                            style={{ cursor: 'pointer', marginLeft: '10px' }}
                          >
                            <Icon name='close' />
                          </Button>
                        </div>
                      ) : (
                        <span>
                          Asset ID
                          <Icon
                            name='search'
                            onClick={() => this.handleAssetFilter('id', true)}
                            style={{ cursor: 'pointer', marginLeft: '10px' }}
                          />
                        </span>
                      )}
                    </th>
                    <th>
                      {assetFilter.name ? (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Search
                            onSearchChange={(e, data) =>
                              this.handleAssetFilter('name', data.value)
                            }
                            value={
                              typeof assetFilter.name === 'string'
                                ? assetFilter.name
                                : ''
                            }
                            placeholder='Search Here...'
                            showNoResults={false}
                            style={{ width: '200px' }}
                          />
                          <Button
                            icon
                            onClick={() =>
                              this.handleAssetFilter('name', false)
                            }
                            style={{ cursor: 'pointer', marginLeft: '10px' }}
                          >
                            <Icon name='close' />
                          </Button>
                        </div>
                      ) : (
                        <span>
                          Name
                          <Icon
                            name='search'
                            onClick={() => this.handleAssetFilter('name', true)}
                            style={{ cursor: 'pointer', marginLeft: '10px' }}
                          />
                        </span>
                      )}
                    </th>

                    {[
                      '6020bcbf1d41c84da5bcb6a3',
                      '660e2797faf103f4ae9b9c8d',
                      '5a8980b01d41c873277771d1',
                      '5abcca6a1d41c85ce9da4f80',
                      '6992a801646454e3da6bd819',
                    ].includes(window.localStorage.getItem('organization')) ? (
                      <th>
                        {assetFilter.chassisNumber ? (
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <Search
                              onSearchChange={(e, data) =>
                                this.handleAssetFilter(
                                  'chassisNumber',
                                  data.value,
                                )
                              }
                              value={
                                typeof assetFilter.chassisNumber === 'string'
                                  ? assetFilter.chassisNumber
                                  : ''
                              }
                              placeholder='Search Here...'
                              showNoResults={false}
                              style={{ width: '200px' }}
                            />
                            <Button
                              icon
                              onClick={() =>
                                this.handleAssetFilter('chassisNumber', false)
                              }
                              style={{ cursor: 'pointer', marginLeft: '10px' }}
                            >
                              <Icon name='close' />
                            </Button>
                          </div>
                        ) : (
                          <span>
                            Chassis Number
                            <Icon
                              name='search'
                              onClick={() =>
                                this.handleAssetFilter('chassisNumber', true)
                              }
                              style={{ cursor: 'pointer', marginLeft: '10px' }}
                            />
                          </span>
                        )}
                      </th>
                    ) : null}

                    {['660e2797faf103f4ae9b9c8d'].includes(
                      window.localStorage.getItem('organization'),
                    ) ? (
                      <th>
                        {assetFilter.engineNumber ? (
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <Search
                              onSearchChange={(e, data) =>
                                this.handleAssetFilter(
                                  'engineNumber',
                                  data.value,
                                )
                              }
                              value={
                                typeof assetFilter.engineNumber === 'string'
                                  ? assetFilter.engineNumber
                                  : ''
                              }
                              placeholder='Search Here...'
                              showNoResults={false}
                              style={{ width: '200px' }}
                            />
                            <Button
                              icon
                              onClick={() =>
                                this.handleAssetFilter('engineNumber', false)
                              }
                              style={{ cursor: 'pointer', marginLeft: '10px' }}
                            >
                              <Icon name='close' />
                            </Button>
                          </div>
                        ) : (
                          <span>
                            Engine Number
                            <Icon
                              name='search'
                              onClick={() =>
                                this.handleAssetFilter('engineNumber', true)
                              }
                              style={{ cursor: 'pointer', marginLeft: '10px' }}
                            />
                          </span>
                        )}
                      </th>
                    ) : null}

                    {['6431047b0b77d9736270689e', '5a8980b01d41c873277771d1', '5abcca6a1d41c85ce9da4f80'].includes(
                      window.localStorage.getItem('organization'),
                    ) ? (
                      <th>
                        {assetFilter.deviceNumber ? (
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <Search
                              onSearchChange={(e, data) =>
                                this.handleAssetFilter(
                                  'deviceNumber',
                                  data.value,
                                )
                              }
                              value={
                                typeof assetFilter.deviceNumber === 'string'
                                  ? assetFilter.deviceNumber
                                  : ''
                              }
                              placeholder='Search Here...'
                              showNoResults={false}
                              style={{ width: '200px' }}
                            />
                            <Button
                              icon
                              onClick={() =>
                                this.handleAssetFilter('deviceNumber', false)
                              }
                              style={{ cursor: 'pointer', marginLeft: '10px' }}
                            >
                              <Icon name='close' />
                            </Button>
                          </div>
                        ) : (
                          <span>
                            Device Number
                            <Icon
                              name='search'
                              onClick={() =>
                                this.handleAssetFilter('deviceNumber', true)
                              }
                              style={{ cursor: 'pointer', marginLeft: '10px' }}
                            />
                          </span>
                        )}
                      </th>
                    ) : null}

                    {['660e2797faf103f4ae9b9c8d'].includes(
                      window.localStorage.getItem('organization'),
                    ) ? (
                      <th>
                        <span>Installation Date</span>
                      </th>
                    ) : null}

                    <th>
                      <span>Bill Clear Up To</span>
                      <Icon
                        name={
                          assetSort.valid === 'asc'
                            ? 'sort ascending'
                            : assetSort.valid === 'dsc'
                              ? 'sort descending'
                              : 'sort'
                        }
                        onClick={() =>
                          this.handleAssetSort(
                            'valid',
                            assetSort.valid === 'asc' ? 'dsc' : 'asc',
                          )
                        }
                        style={{ cursor: 'pointer', marginLeft: '10px' }}
                      />
                    </th>
                    <th>
                      <span>Active</span>
                      <Icon
                        name={
                          assetSort.active === 'asc'
                            ? 'sort ascending'
                            : assetSort.active === 'dsc'
                              ? 'sort descending'
                              : 'sort'
                        }
                        onClick={() =>
                          this.handleAssetSort(
                            'active',
                            assetSort.active === 'asc' ? 'dsc' : 'asc',
                          )
                        }
                        style={{ cursor: 'pointer', marginLeft: '10px' }}
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>{connectedAssetsView}</tbody>
              </table>
            </div>
          </Tab.Pane>
        ),
      },
      {
        menuItem: 'Billing',
        render: () => (
          <Tab.Pane attached={false}>
            <Link to='/monthlybill'>
              <span style={{ marginLeft: '10px' }}>
                {' '}
                <Button content='Click here ' />{' '}
              </span>
            </Link>
            <span>To Pay your Bill</span>
          </Tab.Pane>
        ),
      },
      {
        menuItem: 'Change password',
        render: () => (
          <Tab.Pane attached={false}>
            <div>
              <Form onSubmit={this.handleSubmit}>
                {currentPasswordComponent}
                <Form.Group>
                  <Form.Input
                    label='New password'
                    type='password'
                    placeholder='Password'
                    name='newPassword'
                    value={newPassword}
                    onChange={this.handleChange}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    label='Confirm password'
                    type='password'
                    placeholder='Password'
                    name='confirmPassword'
                    value={confirmPassword}
                    onChange={this.handleChange}
                  />
                </Form.Group>
                <Form.Group style={{ marginTop: '10px' }}>
                  <Form.Button
                    disabled={!newAndConfirmedPasswordMatch}
                    content='Submit'
                  />
                </Form.Group>
              </Form>
            </div>
          </Tab.Pane>
        ),
      },
    ];
    if (name !== 'DEFAULT') {
      return (
        <div>
          <Grid divided='vertically' style={style.containerHeader}>
            <Grid.Row columns={4}>
              <Grid.Column>
                <div className='border-right'>
                  <p className='minimal-information-header'>
                    <strong> {name} </strong>
                  </p>
                  <dl className='minimal-information'>Consumer</dl>
                </div>
              </Grid.Column>
              <Grid.Column>
                <div className='border-right'>
                  <p className='minimal-information-header'>
                    <strong>{connectedAssets.length}</strong>
                  </p>
                  <dl className='minimal-information'>Assets</dl>
                </div>
              </Grid.Column>
              <Grid.Column>
                <div className='border-right'>
                  <p className='minimal-information-header'>
                    <strong> {mobile || 'Empty'} </strong>
                  </p>
                  <dl className='minimal-information'>Mobile</dl>
                </div>
              </Grid.Column>
              <Grid.Column>
                <div>
                  <p className='minimal-information-header'>
                    <strong> {email || 'Empty'} </strong>
                  </p>
                  <dl className='minimal-information'>Email</dl>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <div className='menu-x'>
            <Tab
              menu={{ secondary: true }}
              panes={panes}
              style={style.containerBotton}
              className='profile-tab'
            />
          </div>
        </div>
      );
    } else {
      return <Spinner />;
    }
  }
}

const style = {
  containerHeader: {
    marginRight: '10%',
    marginLeft: '10%',
  },
  containerBotton: {
    marginRight: '10%',
    marginLeft: '10%',
  },
};

export default UserProfile;
